var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { TextAlignHelper } from '../../shared/helpers/text-align-helper';
import { FontStyleHelper } from '../../shared/helpers/font-style-helper';
import { FontSizeHelper } from '../../shared/helpers/font-size-helper';
import { ElementSettingModalBase } from '../base/element-setting-modal-base';
var FontElementSettingModal = /** @class */ (function (_super) {
    __extends(FontElementSettingModal, _super);
    function FontElementSettingModal() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * load font style info
     * @param componentData : current edited component
     */
    FontElementSettingModal.prototype.loadFontInfo = function (componentData) {
        var self = this;
        // load font info
        self.isUnderline = componentData.isUnderline;
        self.textAlign = componentData.textAlign ? componentData.textAlign : TextAlignHelper.AlignCenter;
        self.fontSize = componentData.fontSize ? componentData.fontSize : FontSizeHelper.defaultFontSize;
        self.fontColor = componentData.stroke ? componentData.stroke : FontStyleHelper.defaultFontColor;
        self.fontStyle = componentData.font;
    };
    /**
     * save font style info
     */
    FontElementSettingModal.prototype.saveFontInfo = function () {
        var self = this;
        self.saveComponentProperty('fontSize', self.fontSize);
        self.saveComponentProperty('font', self.fontStyle);
        self.saveComponentProperty('isUnderline', self.isUnderline);
        self.saveComponentProperty('textAlign', self.textAlign);
        self.saveComponentProperty('stroke', self.fontColor);
    };
    return FontElementSettingModal;
}(ElementSettingModalBase));
export { FontElementSettingModal };
